import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpXsrfTokenInterceptorService implements HttpInterceptor {

    private readonly xsrfTokenHeaderName = 'X-XSRF-TOKEN';

    constructor(private tokenExtractor: HttpXsrfTokenExtractor) {
    }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {

        const token: string | null = this.tokenExtractor.getToken();

        if (token !== null && !httpRequest.headers.has(this.xsrfTokenHeaderName)) {
            httpRequest = httpRequest.clone(
                {headers: httpRequest.headers.set(this.xsrfTokenHeaderName, token)}
            );
        }

        return next.handle(httpRequest);
    }
}
